var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#1F1F1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6188 8.67444L15.8256 5.88131C15.7444 5.80005 15.6479 5.73559 15.5417 5.69161C15.4356 5.64764 15.3218 5.625 15.2069 5.625C15.092 5.625 14.9782 5.64764 14.872 5.69161C14.7658 5.73559 14.6694 5.80005 14.5881 5.88131L6.88125 13.5888C6.79984 13.6699 6.73528 13.7664 6.6913 13.8726C6.64732 13.9788 6.62479 14.0926 6.625 14.2076V17.0007C6.625 17.2328 6.71719 17.4553 6.88128 17.6194C7.04538 17.7835 7.26794 17.8757 7.5 17.8757H10.2931C10.4081 17.8759 10.5219 17.8534 10.6281 17.8094C10.7343 17.7654 10.8307 17.7009 10.9119 17.6194L18.6188 9.91194C18.7 9.83069 18.7645 9.73422 18.8085 9.62806C18.8524 9.52189 18.8751 9.4081 18.8751 9.29319C18.8751 9.17827 18.8524 9.06449 18.8085 8.95832C18.7645 8.85215 18.7 8.75569 18.6188 8.67444ZM10.3813 17.0888C10.3579 17.1123 10.3262 17.1256 10.2931 17.1257H7.5C7.46685 17.1257 7.43506 17.1125 7.41161 17.0891C7.38817 17.0656 7.375 17.0338 7.375 17.0007V14.2076C7.37514 14.1745 7.3884 14.1428 7.41188 14.1194L13 8.53069L15.9694 11.5007L10.3813 17.0888ZM18.0881 9.38194L16.5 10.9701L13.5306 8.00069L15.1188 6.41194C15.1304 6.40032 15.1441 6.3911 15.1593 6.38481C15.1745 6.37852 15.1908 6.37528 15.2072 6.37528C15.2236 6.37528 15.2399 6.37852 15.2551 6.38481C15.2702 6.3911 15.284 6.40032 15.2956 6.41194L18.0881 9.20506C18.0997 9.21667 18.109 9.23046 18.1153 9.24563C18.1215 9.26081 18.1248 9.27707 18.1248 9.2935C18.1248 9.30993 18.1215 9.32619 18.1153 9.34137C18.109 9.35654 18.0997 9.37033 18.0881 9.38194Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.5447552a65d76a7cf74801e09ca1683d.svg";
export { ForwardRef as ReactComponent };